"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSpacer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_dnd_1 = require("react-dnd");
var context_1 = require("./context");
var TreeSpacer = function (_a) {
    var numItems = _a.numItems;
    var _b = (0, context_1.useTreeContext)(), canDrop = _b.canDrop, onMove = _b.onMove;
    var _c = (0, react_dnd_1.useDrop)(function () { return ({
        accept: 'NODE',
        collect: function (monitor) { return ({
            showLine: monitor.isOver() && monitor.canDrop(),
        }); },
        canDrop: function (item) {
            if (canDrop) {
                return canDrop({
                    movedNode: item.data,
                    newIndex: numItems,
                    previousIndex: item.index,
                    previousParent: item.parent,
                });
            }
            return true;
        },
        drop: function (item, monitor) {
            if (monitor.didDrop()) {
                return;
            }
            onMove === null || onMove === void 0 ? void 0 : onMove({
                movedNode: item.data,
                newIndex: numItems,
                previousIndex: item.index,
                previousParent: item.parent,
            });
        },
    }); }, [numItems]), showLine = _c[0].showLine, drop = _c[1];
    return ((0, jsx_runtime_1.jsx)("div", { ref: drop, className: (0, classnames_1.default)('tree-spacer flex-grow-1', showLine && 'tree-is-over'), "data-testid": "tree-spacer" }));
};
exports.TreeSpacer = TreeSpacer;
